import {localhost} from "./server";
const apiURL = "/api";

export const endpoint = `${localhost}${apiURL}`;

export const authURL = `${endpoint}/verify_token_login/`;
export const loginURL = `${endpoint}/token/`;
export const logoutURL = `${endpoint}/logout/`;
export const systemInfoURL = `${endpoint}/data_system`;
export const userInfoURL = `${endpoint}/infor-user/`;
export const token_refresh_URL = `${endpoint}/token/refresh/`;
export const listCaLamViecURL = `${endpoint}/ca-lam-viec/`;
export const listLamViecURL = `${endpoint}/lich-lam-hc/`;
export const listLamTuDongURL = `${endpoint}/lich-lam-tudong/`;
export const resetPassUrl = `${endpoint}/reset-pass/`;
export const checkUserHomeUrl = `${endpoint}/check-user-home/`;

export const listMemberOfTeamURL = `${endpoint}/quan-ly-user-team/`;
export const listTeamOfMemberManagerURL = `${endpoint}/quan-ly-team/`;
export const listTeamURL = `${endpoint}/team/`;
export const changeTeamURL = `${endpoint}/change-team/`;
export const listMemberAvailableURL = `${endpoint}/kiem-tra-lich-lam-hc/`;
export const cloneLichLamViecURL = `${endpoint}/lich-lam-hc-cu/`;
export const listLoaiDeNghiURL = `${endpoint}/loai-de-nghi/`;
export const listDeNghiChamCongURL = `${endpoint}/de-nghi-cham-cong/`;
export const listDeNghiChamCongQuanLyURL = `${endpoint}/xet-duyet-de-nghi/`;
export const approveRequestLeaveSPURL = `${endpoint}/xet-dn-phep-db/`;
export const listDeNghiPhepDBURL = `${endpoint}/de-nghi-phep-db/`;
export const remainingLeaveDaysURL = `${endpoint}/remain-leave-day/`;


export const listMyCalendarURL = `${endpoint}/cham-cong/`;
export const MyDetailCalendarURL = `${endpoint}/chi-tiet-cham-cong/`;
export const QuanLyChiTietCongURL = `${endpoint}/chi-tiet-cham-cong-quan-ly/`;
export const NhanSuChiTietCongURL = `${endpoint}/chi-tiet-cham-cong-nhan-su/`;
export const TongHopChamCongURL = `${endpoint}/tong-hop-cham-cong-ns/`;
export const TongHopChamCongQuanLyURL = `${endpoint}/tong-hop-cham-cong-ql/`;
export const ChotCongURL = `${endpoint}/chot-cong-ns/`;

export const listOTURL = `${endpoint}/lich-lam-ot/`;
export const listOTViewURL = `${endpoint}/lich-lam-ot-view/`; // 141024 Thay thế view cũ
export const listOTHRURL = `${endpoint}/lich-lam-ot-nhan-su/`;
export const listOTDacBietURL = `${endpoint}/lich-ot-dac-biet/`;
export const listDuAnURL = `${endpoint}/du-an/`;
export const chinhSuaChamCongURL = `${endpoint}/chinh-sua-cham-cong/`;
export const listLichSuChinhSuaURL = `${endpoint}/lich-su-chinh-sua-cham-cong/`;
export const statusApprovalOTURL = `${endpoint}/trang-thai-duyet-ot/`;
export const statusURL = `${endpoint}/trang-thai-duyet/`;
export const changeStatusOTURL = `${endpoint}/thay-doi-trang-thai-ot/`;
export const changeStatusOTHRURL = `${endpoint}/thay-doi-trang-thai-ot-ns/`;
export const changeStatusCCURL = `${endpoint}/thay-doi-trang-thai-hc/`;
export const changeStatusCCHRURL = `${endpoint}/thay-doi-trang-thai-hc-ns/`;

export const listLichSuChamCongURL = `${endpoint}/lich-su-cham-cong/`;

export const listLeTeTURL = `${endpoint}/lich-le-tet/`;
export const listNgayNghiURL = `${endpoint}/lich-ngay-nghi/`;

// Bảng phép
export const listBangPhepNSURL = `${endpoint}/bang-phep-ca-nhan/`;
export const listBangPhepQLURL = `${endpoint}/bang-phep-ca-nhan-ql/`;
export const dieuChinhPhepCaNhanURL = `${endpoint}/dieu-chinh-phep/`;
export const duyetPhepTeamURL = `${endpoint}/duyet-phep-thang/`;
export const resultLeaveDaysURL = `${endpoint}/result-leave-days/`;


export const exportExcelTempStaffURL = `${endpoint}/export_temp_staff/`;
export const exportExcelStaffURL = `${endpoint}/export_staff/`;
export const uploadExcelTempURL = `${endpoint}/import_excel_temp_staff/`;
export const exportExcelTongHopCongURL = `${endpoint}/export_tonghopcong/`;
export const exportExcelTongCongURL = `${endpoint}/export_tongcong/`;
export const exportExcelTongHopOTNSURL = `${endpoint}/export_tonghop_otns/`;
export const exportExcelOTNS_DBURL = `${endpoint}/export-otns-dac-biet/`;
export const exportExcelTempHolidayURL = `${endpoint}/export_temp_holiday/`;
export const uploadExcelHolidayURL = `${endpoint}/import_excel_temp_holiday/`;

export const listUserURL = `${endpoint}/infor-all-user/`;
export const listRoleURL = `${endpoint}/list_role/`;
export const listGroupRoleURL = `${endpoint}/group_role/`;
export const userEditURL =  id => `${endpoint}/user/${id}`;
export const listPhuongThucCCURL = `${endpoint}/phuong-thuc-cham-cong/`;
export const listLoaiNVURL = `${endpoint}/loai-nhan-vien/`;
export const listLoaiUserURL = `${endpoint}/loai-user/`;
export const listChucVuURL = `${endpoint}/chuc-vu/`;
export const handUserURL = `${endpoint}/create-user/`;
export const updateRoleUserURL = `${endpoint}/create-role-user/`;

// Chuyển trả đề nghị chế độ
export const regimeCancelURL = `${endpoint}/regime-cancel/`;


// Cam ket WFH
export const listThietBiWFHURL = `${endpoint}/thiet-bi-wfh/`;
export const dangKyWFHURL = `${endpoint}/dang-ki-wfh/`;
export const dangKyWFHQLyURL = `${endpoint}/xet-duyet-wfh/`;
export const detailWFHURL =  id => `${endpoint}/detail-infor-wfh/${id}`;

export const listBoPhanURL = `${endpoint}/bo-phan/`;
export const listChiTietBoPhanURL = `${endpoint}/chi-tiet-bo-phan/`;

export const listTotalTimeURL = `${endpoint}/thong-ke-cong-ca-nhan/`;
export const renewPassURL = tok => `${endpoint}/renewpass/${tok}`;


// Cấu hình - Chấm công sáng thứ 7
export const autoAttendURL = `${endpoint}/auto-attend/`;

// ISMS
export const listTypeQuestionURL = `${endpoint}/list-type-question/`;
export const listOfQuestionURL = `${endpoint}/list-of-question/`;
export const listExamMaterialsURL = `${endpoint}/exam-materials/`;
export const submitIsmsURL = `${endpoint}/submit-isms/`;
export const quizURL = `${endpoint}/quiz/`;
export const questiontypeURL = `${endpoint}/question-type/`;
export const setExamURL = `${endpoint}/set-exam/`;
export const groupISMSUserURL = `${endpoint}/group-isms-user/`;
export const documentISMSURL = `${endpoint}/exam-materials/`;
export const resultExamURL = `${endpoint}/result-exam/`;
export const exportResultExamURL = `${endpoint}/export-result-exam/`;
export const exportExamURL = `${endpoint}/export-exam/`;
export const userGroupAllURL = `${endpoint}/user-group-all/`;
export const resultISMSURL = `${endpoint}/result-isms/`;

// export const changePassURL = `${endpoint}/infor-user/`;